import { useState } from "react";
import rehypeTruncate from "rehype-truncate";
import { tv } from "tailwind-variants";

import { Heading, icons, MarkdownRenderer, pillToggle, Reveal } from "@/ui";

const sourceOfKnowledgeCardVariants = tv({
  slots: {
    chevron: "size-4 shrink-0 transition-transform duration-300",
  },
  variants: {
    isExpanded: {
      true: {
        chevron: "rotate-180",
      },
    },
  },
});

const { chevron } = sourceOfKnowledgeCardVariants();

type SourceOfKnowledgeCardProps = {
  title: string;
  content: string;
};

const SOURCE_OF_KNOWLEDGE_TRUNCATE_LENGTH = 250;

export const SourceOfKnowledgeCard = ({ content, title }: SourceOfKnowledgeCardProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="flex flex-col items-start gap-4 text-content-secondary">
      <div className="flex flex-col gap-2">
        <Heading level={3}>{title}</Heading>

        <Reveal>
          <MarkdownRenderer
            rehypePlugins={[
              [
                rehypeTruncate,
                { maxChars: SOURCE_OF_KNOWLEDGE_TRUNCATE_LENGTH, disable: isExpanded },
              ],
            ]}
          >
            {content}
          </MarkdownRenderer>
        </Reveal>
      </div>

      <button
        aria-expanded={isExpanded}
        className={`${pillToggle} py-2 text-base sm:text-base`}
        onClick={() => {
          return setIsExpanded((expanded) => {
            return !expanded;
          });
        }}
        type="button"
      >
        {isExpanded ? "Show less" : "Read more"}
        <icons.ChevronDownIcon aria-hidden="true" className={chevron({ isExpanded })} />
      </button>
    </div>
  );
};
